import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

export type PostSigninParams = {
  email: string;
  password: string;
};

export type PostSigninResponse = APIResponse<{
  token: string;
}>;

export const postSignin = async (params: PostSigninParams) => {
  return await http<PostSigninResponse>('/user/v1/login', {
    method: 'POST',
    body: JSON.stringify({
      oem_service_id: process.env.NEXT_PUBLIC_SERVICE_ID,
      email: params.email,
      password: params.password,
    }),
  });
};
